import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const CheckboxUncheckedIcon = props => {
  return (
    <Svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.317.769a42.502 42.502 0 019.366 0c1.827.204 3.302 1.642 3.516 3.48.37 3.156.37 6.345 0 9.502-.215 1.837-1.69 3.276-3.516 3.48a42.511 42.511 0 01-9.366 0C2.49 17.027 1.015 15.588.8 13.751a40.902 40.902 0 010-9.503C1.015 2.411 2.49.973 4.317.768zm9.2 1.49a41.002 41.002 0 00-9.034 0A2.486 2.486 0 002.29 4.423a39.402 39.402 0 000 9.154 2.486 2.486 0 002.193 2.163c2.977.333 6.057.333 9.034 0a2.486 2.486 0 002.193-2.163 39.401 39.401 0 000-9.154 2.486 2.486 0 00-2.193-2.164z"
        fill="#8697AB"
      />
    </Svg>
  );
};

export default CheckboxUncheckedIcon;
